export class SearchModelBlockItem {
  constructor(all=false) {
    this.idx = Math.random()

    // <search id="id" type="field" operator="null-not"/>


    if (all) {
      this.field = {
       id: 'id',
       type: 'field'
      }
      this.compare = {
        id: 'null-not'
      }
    }
  }
  idx = ''
  field = null
  compare = null
  values = []
  date = {
    year: null,
    month: null,
    day: null,
    hour: null,
    minute: null
  }
}

export class SearchModelBlock {
  searches = []
  constructor(prefill=false, all=false) {
    if (prefill) {
      const search = new SearchModelBlockItem(all)
      this.searches = [search]
    }
  }
}

export class SearchModel {
  name = ''
  count = 0
  item = null
  own = false
  blocks = []
  constructor(prefill=false, all=false) {
    if (prefill) {
      this.own = true
      const block = new SearchModelBlock(prefill, all)
      this.blocks = [block]
    }
  }
  isValid() {
    let res = true
    this.blocks.forEach(b => {
      b.searches.forEach(s => {
        if (!s.field) {
          res = false
        }
      })
    })
    return res
  }
}


